import { render, staticRenderFns } from "./ManagementPaymentsPage.vue?vue&type=template&id=c7024e60"
import script from "./ManagementPaymentsPage.vue?vue&type=script&lang=js"
export * from "./ManagementPaymentsPage.vue?vue&type=script&lang=js"
import style0 from "./ManagementPaymentsPage.vue?vue&type=style&index=0&id=c7024e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports